'use strict';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {I18nComponent} from '../../../react-i18n';
import {NotificationList} from '../NotificationList';

export class BaseNotificationPanelComponent extends Component {
  static propTypes = {
    className: T.string,
    list: T.array,
    show: T.bool,
    onSweep: T.func,
    onShow: T.func,
    onHide: T.func,

    headerLabel: T.string,
    sweepLabel: T.string,
    closeLabel: T.string,
  };

  render() {
    const props = this.props;
    return (
      <div
        className={classNames("NotificationPanel", props.className, {
          show: props.show,
        })}
      >
        <div className="NotificationPanel__body">
          <div className="mini-modal-header">
            <i
              className="icon swift-sweep sweep-btn"
              onClick={props.onSweep}
              title={props.sweepLabel}
            />
            <span>
              {props.headerLabel}
            </span>
            <i
              className="icon ion-android-close close-btn"
              onClick={props.onHide}
              title={props.closeLabel}
            />
          </div>

          {props.show ? (
            <NotificationList
              className="NotificationPanel__list"
              list={props.list}
              onRemove={props.onRemove}
            />
          ) : null}

          <div
            className="NotificationPanel__footer"
            onClick={props.onHide}
          >
            <i className="icon ion-ios-arrow-up" />
            <span>
              Hide
            </span>
            <i className="icon ion-ios-arrow-up" />
          </div>
        </div>
      </div>
    );
  }
}

export const NotificationPanelComponent = I18nComponent(BaseNotificationPanelComponent, [
  {code: 'notifications.header.label', prop: 'headerLabel'},
  {code: 'icon.sweep.title', prop: 'sweepLabel'},
  {code: 'icon.close.title', prop: 'closeLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/core-utilities/notifications/components/NotificationPanel/NotificationPanelComponent.js